<template>
  <van-form class="vg-form">
    <slot></slot>
  </van-form>
</template>

<script>
import {Form} from "vant";

export default {
  name: "VgForm",
  components: {
    'van-form': Form
  }
}
</script>

<style scoped>
.vg-form {
  font-size: 16px;
  /*font-weight: 550;*/
}

/*.vg-form > .vg-field {*/
/*  margin-bottom: 8px;*/
/*}*/

/*.vg-form > .vg-field {*/
/*  justify-content: space-between;*/
/*}*/

.vg-form >>> .vg-field::after {
  content: none;
}

.vg-form >>> > .vg-field-wrapper:last-child::after,
.vg-form >>> > :last-child .vg-field-wrapper::after{
  content: none;
}

.vg-form >>> .vg-field-wrapper {
  position: relative;
}

.vg-form >>> .vg-field-wrapper::after {
  content: "";
  position: absolute;
  border-bottom: solid 1px #E7E5E7;
  left: 10px;
  right: 10px;
  bottom: 0;
  transform: none;
}

</style>